export default function CTASection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
          あなたの夢を実現する<br />パートナーになります
        </h2>
        <p className="text-sm md:text-xl text-teal-100 mb-8 md:mb-12 leading-relaxed">
          飲食店の開業・経営改善のお悩み、まずは無料相談でお聞かせください。<br className="hidden md:block" />
          実践的なノウハウで、あなたのビジネスの成功をサポートします。
        </p>
        <button
          onClick={() => scrollToSection('contact')}
          className="bg-white text-teal-700 px-8 md:px-10 py-4 md:py-5 rounded-full text-sm md:text-lg font-bold hover:bg-gray-50 transition-all inline-flex items-center gap-2 md:gap-3 whitespace-nowrap cursor-pointer"
        >
          無料相談を予約する
          <i className="ri-arrow-right-line md:text-xl"></i>
        </button>
      </div>
    </section>
  );
}
